import request from '@/services/interceptor.js'

export const get_tipiDispositivoSicurezza = () => {
    return request({ url: '/tipodispositivosicurezza', method: 'get', loadingBar: true })
}

export const create_tipoDispositivoSicurezza = (par) => {
    return request({ url: '/tipodispositivosicurezza', method: 'post', data: par, loadingBar: true })
}

export const update_tipoDispositivoSicurezza = (id, par) => {
    return request({ url: `/tipodispositivosicurezza/${id}`, method: 'put', data: par, loadingBar: true })
}

export const duplica_tipoDispositivoSicurezza = (id) => {
    return request({ url: `/tipodispositivosicurezza/${id}/duplica`, method: 'post', loadingBar: true })
}

export const delete_tipoDispositivoSicurezza = (id) => {
    return request({ url: `/tipodispositivosicurezza/${id}`, method: 'delete', loadingBar: true })
}
